<template>
    <div
        class="sp-loader"
        :class="{
            'sp-loader--overlay': overlay,
            'sp-loader--compact': compact,
        }"
        :aria-busy="true"
        :aria-label="label || 'Загрузка'"
    >
        <SpinnerLoader />
        <span v-if="label" class="sp-loader__label">{{ label }}</span>
    </div>
</template>

<script>
import SpinnerLoader from '@/components/SpinnerLoader.vue'

export default {
    name: 'StarterPackLoader',
    components: { SpinnerLoader },
    props: {
        label: {
            type: String,
            default: '',
        },
        overlay: {
            type: Boolean,
            default: false,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.sp-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 280px;
    padding: 48px 24px;
}

.sp-loader--compact {
    min-height: 120px;
    padding: 24px 13px;
    background: #f6f7f9;
    border: 1px dashed $border-new;
    border-radius: 10px;
}

.sp-loader--overlay {
    position: absolute;
    inset: 0;
    z-index: 2;
    min-height: 0;
    padding: 24px;
    background: rgba(255, 255, 255, 0.72);
    border-radius: 10px;
}

.sp-loader__label {
    color: $text-color-new;
    font-size: 13px;
    line-height: 1.4;
    text-align: center;
}
</style>
